import { api } from "@/api/client";
import type { CreditCostDto, CreditPackDto, WalletMe } from "@/types/api";

export async function getWalletMe(): Promise<WalletMe> {
  return api<WalletMe>("/wallet/me");
}

export async function listCreditCosts(): Promise<CreditCostDto[]> {
  return api<CreditCostDto[]>("/wallet/costs");
}

export async function listCreditPacks(): Promise<CreditPackDto[]> {
  return api<CreditPackDto[]>("/wallet/packs", { skipAuth: true });
}

export async function purchasePack(packKey: string): Promise<unknown> {
  return api(`/wallet/packs/${encodeURIComponent(packKey)}/purchase`, {
    method: "POST",
  });
}

export async function subscribePlan(planKey: string): Promise<unknown> {
  return api(`/wallet/subscribe/${encodeURIComponent(planKey)}`, {
    method: "POST",
  });
}
